import { render, staticRenderFns } from "./stationMessage.vue?vue&type=template&id=4d1c799c&scoped=true&"
import script from "./stationMessage.vue?vue&type=script&lang=js&"
export * from "./stationMessage.vue?vue&type=script&lang=js&"
import style0 from "./stationMessage.vue?vue&type=style&index=0&id=4d1c799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c799c",
  null
  
)

export default component.exports